import { Config } from "../config";

export interface ApiFetchOptions extends Omit<RequestInit, "headers"> {
    token?: string | null;
    headers?: Record<string, string>;
}

// Centralizes the API base URL and Authorization/Content-Type headers that
// were previously duplicated across FolderContents, PreviewPane and
// ComposeMailItem. Callers still own their own useEffect/AbortController/
// loading state - this only removes the copy-pasted URL/header construction.
export function apiFetch(path: string, options: ApiFetchOptions = {}): Promise<Response> {
    const { token, headers, ...rest } = options;
    return fetch(Config.apiEndpoint + path, {
        mode: "cors",
        ...rest,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { "Authorization": "Bearer " + token } : {}),
            ...headers
        }
    });
}
